/*
 *
 * SearchTerm constants
 *
 */

export const CHANGE_SEARCHTERM = 'CHANGE_SEARCHTERM';
export default CHANGE_SEARCHTERM;
